function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import ThunkHelper from 'invision-core/src/api/thunk.helper';
export var SEARCH_EXISTING_CUSTOMERS = {
  BEGIN: 'SEARCH_EXISTING_CUSTOMERS_BEGIN',
  SUCCESS: 'SEARCH_EXISTING_CUSTOMERS_SUCCESS',
  FAILURE: 'SEARCH_EXISTING_CUSTOMERS_FAILURE'
};
var SEARCH_EXISTING_CUSTOMERS_EVENTS = [SEARCH_EXISTING_CUSTOMERS.BEGIN, SEARCH_EXISTING_CUSTOMERS.SUCCESS, SEARCH_EXISTING_CUSTOMERS.FAILURE];
export var RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH = {
  BEGIN: 'RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH_BEGIN',
  SUCCESS: 'RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH_SUCCESS',
  FAILURE: 'RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH_FAILURE'
};
var RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH_EVENTS = [RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.BEGIN, RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.SUCCESS, RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH.FAILURE];
var searchExistingCustomersPromise = function searchExistingCustomersPromise(dispatch, searchOtherCustomerModel) {
  return ThunkHelper(dispatch, SEARCH_EXISTING_CUSTOMERS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscribers',
    data: {
      FirstName: searchOtherCustomerModel.firstName,
      LastName: searchOtherCustomerModel.lastName,
      CompanyName: searchOtherCustomerModel.companyName,
      LoginOrEmailAddress: searchOtherCustomerModel.email,
      PageSize: 100,
      PageNumber: 1,
      PhoneNumber: searchOtherCustomerModel.phoneNumber,
      SubscriberId: searchOtherCustomerModel.customerId || undefined,
      Title: searchOtherCustomerModel.title || undefined
    }
  });
};
var retrieveHouseholdsPromise = function retrieveHouseholdsPromise(dispatch, subscriberId) {
  return ThunkHelper(dispatch, RETRIEVE_HOUSEHOLDS_FOR_CUSTOMER_SEARCH_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveHouseholds',
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, subscriberId)
  });
};
export var searchExistingCustomers = function searchExistingCustomers(searchOtherCustomerModel) {
  return function (dispatch) {
    return searchExistingCustomersPromise(dispatch, searchOtherCustomerModel);
  };
};
export var searchHouseholdMembers = function searchHouseholdMembers(subscriberId) {
  return function (dispatch) {
    return retrieveHouseholdsPromise(dispatch, subscriberId);
  };
};
export var RESET_SEARCH_OTHER_CUSTOMERS_STORE = 'RESET_SEARCH_OTHER_CUSTOMERS_STORE';
export var resetSearchOtherCustomersStore = function resetSearchOtherCustomersStore() {
  return {
    type: RESET_SEARCH_OTHER_CUSTOMERS_STORE
  };
};